import { inject, injectable } from "inversify";
import { TYPES } from "./ioc/types";
import { Store } from "@reduxjs/toolkit";
import { PrimariaApi } from "@uxland/primary-shell";

@injectable()
export class StoreBaseHandler {
  constructor(@inject(TYPES.store) protected readonly store: Store) {}
}

@injectable()
export class ApiBaseHandler {
  constructor(@inject(TYPES.primaryApi) protected readonly api: PrimariaApi) {}
}

@injectable()
export class BaseHandler {
  constructor(
    @inject(TYPES.store) protected readonly store: Store,
    @inject(TYPES.primaryApi) protected readonly api: PrimariaApi,
  ) {}
}
